import { render, staticRenderFns } from "./carouselManagement.vue?vue&type=template&id=304e49b6&scoped=true"
import script from "./carouselManagement.vue?vue&type=script&lang=js"
export * from "./carouselManagement.vue?vue&type=script&lang=js"
import style0 from "./carouselManagement.vue?vue&type=style&index=0&id=304e49b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304e49b6",
  null
  
)

export default component.exports